export default () => jQuery(($) => {
	$('.copyLinkToClipboard').click(function (e) {
		e.preventDefault();
		var target = $(this);
		var originalText = target.text();
		console.log('Copying link:', $(this).attr('href'));
		navigator.clipboard.writeText($(this).attr('href'));
		target.text('Link Copied!');
		setTimeout(function () {
			target.text(originalText);
			target.blur();
		}, 3000);
	});
});
